// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"69de4c5d","455":"304d12ab","946":"fc04e6a5"}[chunkId] + ".chunk.js";
};